import moment from 'moment'
// 定义全局自增ID
var atomicLong = 1

export function timeFix () {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

export function isIE () {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

/** 生成自增序列号（不重复） **/
export function genRowKey () {
  return new Date().getTime() + '_' + (atomicLong++)
}

/**
 * 格式化金额，添加千分位和货币符号
 * @param {number|string} amount 金额
 * @param {string} [currency='₹'] 货币符号
 * @param {number} [decimal=2] 小数位数
 * @returns {string} 格式化后的金额
 */
export function formatAmount (amount, currency = '₹', decimal = 2) {
  if (amount === undefined || amount === null || amount === '') return currency + '0.00'
  return currency + Number(amount).toLocaleString('en-US', {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal
  })
}

/**
 * 格式化数字，添加千分位（不带货币符号）
 * @param {number|string} number 数字
 * @param {number} [decimal=2] 小数位数
 * @returns {string} 格式化后的数字
 */
export function formatNumber (number, decimal = 2) {
  if (number === undefined || number === null || number === '') return '0.00'
  return Number(number).toLocaleString('en-US', {
    minimumFractionDigits: decimal,
    maximumFractionDigits: decimal
  })
}

export function formatTime (time) {
  if (time === undefined || time === null || time === '' || time === 0) return '--'
  return moment(time).format('YYYY-MM-DD HH:mm:ss')
}
